import styled from 'styled-components';

export const DrawFieldContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;
